import moment from "moment";
import {AlgorithmKey} from "@/environment";

class Helpers {
    uploadImage(fileInput) {
        if (fileInput) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(fileInput)
                reader.onload = () => resolve(reader.result)
                reader.onerror = (error) => reject(error)
            })
        }
        else {
            // do nothing
        }
    }
    removeTags(str) {
        return str.replace(/(<([^>]+)>)/ig, '')
    }
    formatCurrency(val) {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'KES',
        });
        return formatter.format(val)
    }
    formatDate(date) {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a')
    }
    encrypt(value) {
        return btoa(AlgorithmKey + value)
    }
    decrypt(value) {
        return atob(value);
    }
    removeBlankAttributes(obj){
        return Object.fromEntries(
            Object.entries(obj).filter(([, value]) => value)
        );
    }
    downloadFile(fileName,content) {
        //
        try{
            const a = document.createElement("a");
            const file = new Blob([content], { type: "text/plain" });
            a.href = URL.createObjectURL(file);
            a.download = fileName;
            a.click();
        } catch (e) {
            console.log(e)
        }
        //
    }
    checkForCapsLock(field) {
        field.addEventListener('keyup',event=>{
            if (event.getModifierState('CapsLock')) {
                console.log('caps lock is on')
            } else {
                console.log('caps lock is off')
            }
        })
    }
    generateBearerToken({clientId, clientSecret}) {
        const encodedCredentials = btoa(`${clientId}:${clientSecret}`);
        return `${encodedCredentials}`;
    }

}
export default new Helpers()
